import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const tradeHistorySchema = z.object({
  /** シンボル（例: "BNBBTC"） */
  symbol: z.string(),
  /** 一意のトレードID */
  id: z.number(),
  /** 注文ID */
  orderId: z.number(),
  /** 注文リストID（例: OCO注文など、-1 は対象外） */
  orderListId: z.number(),
  /** 取引価格 */
  price: decimalSchema,
  /** 取引数量（base asset） */
  qty: decimalSchema,
  /** 通貨換算後の数量（quote asset） */
  quoteQty: decimalSchema,
  /** 手数料量 */
  commission: decimalSchema,
  /** 手数料として支払われたアセット */
  commissionAsset: z.string(),
  /** タイムスタンプ（ミリ秒） */
  time: z.number(),
  /** 自分が買い手かどうか */
  isBuyer: z.boolean(),
  /** メイカーかどうか */
  isMaker: z.boolean(),
  /** 最適一致かどうか */
  isBestMatch: z.boolean(),
})

export const responseSchema = z.array(tradeHistorySchema)
